import { Provider } from './types/providers';
export const AVAILABLE_ACCOUNTS = [Provider.EpicGames, Provider.X];
